export default "__VITE_ASSET__BQLipX5h__"